function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "ic_info_red");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M9,5 L11,5 L11,7 L9,7 L9,5 Z M9,9 L11,9 L11,15 L9,15 L9,9 Z M10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 10,0 Z M10,18 C5.59,18 2,14.41 2,10 C2,5.59 5.59,2 10,2 C14.41,2 18,5.59 18,10 C18,14.41 14.41,18 10,18 Z",
  id: "path-info"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Brand/Collections",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Design/Submitted-for-Sampling(Alert-Message)",
  transform: "translate(-414.000000, -706.000000)"
}, React.createElement("g", {
  id: "Group-16",
  transform: "translate(382.000000, 550.000000)"
}, React.createElement("g", {
  id: "Group-20-Copy-5",
  transform: "translate(1.000000, 150.000000)"
}, React.createElement("g", {
  id: "Group-21",
  transform: "translate(31.000000, 6.000000)"
}, React.createElement("g", {
  id: "icon/action/info_24px"
}, React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-info"
})), React.createElement("use", {
  id: "info_24px",
  fill: "#000126",
  fillRule: "nonzero",
  xlinkHref: "#path-info"
})))))));

var SvgIcInfoBlack = function SvgIcInfoBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcInfoBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-info-black.a3332c34.svg";
export { ForwardRef as ReactComponent };